<template>
  <i-row>
    <i-col span="24">
      <AffixHeader>
        <BreadcrumbItem slot="parent" to="/tabular-datasets"
          >Tabular Datasets</BreadcrumbItem
        >
        <span slot="title">New Tabular Dataset</span>
      </AffixHeader>

      <i-form
        ref="form"
        :model="tabularDataset"
        :rules="rules"
        label-position="top"
      >
        <i-row :gutter="6">
          <i-col span="24">
            <i-form-item label="Name" prop="name">
              <i-input v-model="tabularDataset.name"></i-input>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row :gutter="6">
          <i-col span="8">
            <i-form-item label="Country" prop="iso3">
              <CountrySelect
                v-model="tabularDataset.iso3"
                filterable
              ></CountrySelect>
            </i-form-item>
          </i-col>
          <i-col span="8">
            <i-form-item label="Source" prop="source_id">
              <SourceSelect v-model="tabularDataset.source_id"></SourceSelect>
            </i-form-item>
          </i-col>
          <i-col span="8">
            <i-form-item label="Cause" prop="displacement_type">
              <i-select v-model="tabularDataset.displacement_type" filterable>
                <i-option value="Conflict">Conflict</i-option>
                <i-option value="Disaster">Disaster</i-option>
                <i-option value="Development">Development</i-option>
              </i-select>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row :gutter="6">
          <i-col span="8">
            <i-form-item label="URL" prop="url">
              <i-input v-model="tabularDataset.url" type="url"></i-input>
            </i-form-item>
          </i-col>
          <i-col span="8">
            <i-form-item label="Unit" prop="unit">
              <i-select v-model="tabularDataset.unit" filterable>
                <i-option value="Person">Person</i-option>
                <i-option value="Household">Household</i-option>
              </i-select>
            </i-form-item>
          </i-col>
          <i-col span="8">
            <i-form-item label="Document" prop="document_id">
              <DocumentSelect
                v-model="tabularDataset.document_id"
                filterable
              ></DocumentSelect>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row :gutter="6">
          <i-col span="24">
            <i-form-item label="Comments" prop="comments">
              <i-input
                v-model="tabularDataset.comments"
                type="textarea"
              ></i-input>
            </i-form-item>
          </i-col>
        </i-row>
        <i-row type="flex" justify="end" :gutter="6">
          <i-col>
            <i-button @click="create" type="primary">
              <FFIcon type="save" />Create
            </i-button>
          </i-col>
        </i-row>
      </i-form>
    </i-col>
  </i-row>
</template>
<script>
import TabularDataset from "@/models/TabularDataset.ts";
import CountrySelect from "@/components/country_select.vue";
import DocumentSelect from "@/components/document_select.vue";
import SourceSelect from "@/components/source_select.vue";

export default {
  name: "TabularDataNewForm",
  components: { CountrySelect, DocumentSelect, SourceSelect },
  data() {
    return {
      tabularDataset: new TabularDataset(),
      rules: {
        name: [{ required: true, message: "Name is required" }],
        url: [{ type: "url", message: "URL is not valid" }],
        iso3: [{ required: true, message: "Country is required" }],
        displacement_type: [{ required: true, message: "Cause is required" }],
        unit: [{ required: true, message: "Unit is required" }],
      },
    };
  },
  methods: {
    async create() {
      this.$refs["form"].validate(async valid => {
        if (!valid) {
          this.$Notice.error({
            title: "Form Error",
            desc: "Please check the form for errors",
          });
          return;
        }

        try {
          let response = await this.tabularDataset.create();
          this.loadingSuccess("Successfully created dataset");
          const { id } = response.data;
          this.$router.push(`/tabular-datasets/${id}`);
        } catch (error) {
          console.error(error.response);
          this.$Notice.error({
            title: "Database Error",
            desc: error.response.data.message,
          });
        }
      });
    },
  },
};
</script>
<style></style>
